<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="1250">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-COMMUNITY-PROVIDER-PROGRAM' : 'EDIT-COMMUNITY-PROVIDER-PROGRAM') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{ 'SERVICE' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form tab-program">
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ORGANIZATION' | translate}} {{requiredLabel('ORGANIZATION')}}
                                    </span>
                                    <kendo-combobox id="organization" formControlName="organization" class="w-100"
                                        [valuePrimitive]="false" [itemDisabled]="itemDisabled"
                                        [readonly]="isRestrictedOrganization" [data]="organizations"
                                        [textField]="'name'" [valueField]="'id'" [virtual]="virtualOrganization"
                                        (valueChange)="organizationChange(true)">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="organization.hasError('required') && (organization.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ORGANIZATION')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'SUBMITTING-ORGANIZATION' | translate}}
                                        {{requiredLabel('SUBMITTING_ORGANIZATION')}}
                                    </span>
                                    <kendo-combobox id="submittingOrganization" formControlName="submittingOrganization"
                                        class="w-100" [valuePrimitive]="false" [itemDisabled]="itemDisabled"
                                        [data]="submittingOrganizations" [textField]="'name'" [valueField]="'id'"
                                        [virtual]="virtualSubmittingOrganization">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="submittingOrganization.hasError('required') && (submittingOrganization.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('SUBMITTING_ORGANIZATION')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-2">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STATUS' | translate}} {{requiredLabel('STATUS')}}
                                    </span>
                                    <kendo-combobox id="resourceStatus" class="w-100" formControlName="resourceStatus"
                                        [valuePrimitive]="false" [data]="resourceStatuses" [textField]="'displayName'"
                                        [valueField]="'id'">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="resourceStatus.hasError('required') && (resourceStatus.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('STATUS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COMMUNITY-SERVICE-CATEGORY' | translate}}
                                        {{requiredLabel('SERVICE_CATEGORY')}}
                                    </span>
                                    <kendo-combobox id="serviceCategory" formControlName="serviceCategory" class="w-100"
                                        [valuePrimitive]="false" [itemDisabled]="itemDisabled"
                                        [data]="groupedCommunityServiceCategories" [textField]="'name'"
                                        [valueField]="'id'">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="serviceCategory.hasError('required') && (serviceCategory.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('SERVICE_CATEGORY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'REFERRAL-CHANNEL' | translate}} {{requiredLabel('CHANNEL')}}
                                    </span>
                                    <kendo-combobox id="channel" class="w-100" formControlName="channel"
                                        [valuePrimitive]="false" [itemDisabled]="channelItemDisabled"
                                        [data]="groupedChannels" [textField]="'name'" [valueField]="'id'">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="channel.hasError('required') && (channel.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('CHANNEL')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'PROGRAM-NAME' | translate}} {{requiredLabel('NAME')}}
                                    </span>
                                    <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="name.hasError('required') && (name.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('NAME')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="name.hasError('nameExists')">
                                        {{'COMMUNITY-PROVIDER-PROGRAM-ALREADY-EXISTS' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ALIAS' | translate}} {{requiredLabel('ALIAS')}}
                                    </span>
                                    <input id="alias" kendoTextBox formControlName="alias" maxlength="255" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="alias.hasError('required') && (alias.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ALIAS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label for="description" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'DESCRIPTION' | translate }} {{requiredLabel('DESCRIPTION')}}
                                    </span>
                                    <textarea id="description" kendoTextArea class="w-100" formControlName="description"
                                        maxlength="4000">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="description.hasError('required') && (description.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('DESCRIPTION')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label for="eligibility" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'ELIGIBILITY' | translate }} {{requiredLabel('ELIGIBILITY')}}
                                    </span>
                                    <textarea id="eligibility" kendoTextArea class="w-100" formControlName="eligibility"
                                        maxlength="4000" rows="1">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="eligibility.hasError('required') && (eligibility.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ELIGIBILITY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label for="cost" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'COST' | translate }} {{requiredLabel('COST')}}
                                    </span>
                                    <textarea id="cost" kendoTextArea class="w-100" formControlName="cost"
                                        maxlength="4000" rows="1">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="cost.hasError('required') && (cost.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('COST')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label for="languages" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'LANGUAGES' | translate }} {{requiredLabel('LANGUAGES')}}
                                    </span>
                                    <kendo-multiselect id="languages" [data]="languagesFiltered"
                                        formControlName="languages" [textField]="'displayName'" [filterable]="true"
                                        [valueField]="'id'" (filterChange)="filterLanguages($event)"
                                        (close)="searchTerm=''" [autoClose]="true" [virtual]="virtualLanguage">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="languages.hasError('required') && (languages.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('LANGUAGES')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label for="areaServedCities" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'AREAS-SERVED-CITIES' | translate }} {{requiredLabel('AREAS_SERVED_CITIES')}}
                                    </span>
                                    <kendo-multiselect id="areaServedCities" [data]="areaServedCitiesFiltered"
                                        formControlName="areaServedCities" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterAreaServedCities($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualAreaServedCity">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="areaServedCities.hasError('required') && (areaServedCities.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('AREAS_SERVED_CITIES')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label for="areaServedCounties" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'AREAS-SERVED-COUNTIES' | translate }}
                                        {{requiredLabel('AREAS_SERVED_COUNTIES')}}
                                    </span>
                                    <kendo-multiselect id="areaServedCounties" [data]="areaServedCountiesFiltered"
                                        formControlName="areaServedCounties" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterAreaServedCounties($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualAreaServedCounty">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="areaServedCounties.hasError('required') && (areaServedCounties.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('AREAS_SERVED_COUNTIES')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label for="areaServedZipCodes" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'AREAS-SERVED-ZIPCODES' | translate }}
                                        {{requiredLabel('AREAS_SERVED_ZIPCODES')}}
                                    </span>
                                    <kendo-multiselect id="areaServedZipCodes" [data]="areaServedZipCodesFiltered"
                                        formControlName="areaServedZipCodes" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterAreaServedZipCodes($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualAreaServedZipCode">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="areaServedZipCodes.hasError('required') && (areaServedZipCodes.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('AREAS_SERVED_ZIPCODES')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row pb-3">
                            <div class="col-8" *ngIf="allEnhancedServices.length > 0">
                                <label for="enhancedServices" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'ENHANCED-SERVICES-OFFERED' | translate }}
                                        {{requiredLabel('ENHANCED_SERVICE_ELIGIBILITY')}}
                                    </span>
                                    <kendo-multiselect id="enhancedServices" [data]="enhancedServicesFiltered"
                                        formControlName="enhancedServices" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterEnhancedServices($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualEnhancedService">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="enhancedServices.hasError('required') && (enhancedServices.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ENHANCED_SERVICE_ELIGIBILITY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row" style="margin-top:-16px;">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ABLE-TO-CONDUCT-SCREENINGS' | translate}}
                                        {{requiredLabel('ABLE_TO_CONDUCT_SCREENINGS')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="ableToConductScreenings.value === null"
                                        formControlName="ableToConductScreenings" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="ableToConductScreenings.hasError('required') && (ableToConductScreenings.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ABLE_TO_CONDUCT_SCREENINGS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'INFORMATIONAL-ONLY' | translate}}
                                        {{requiredLabel('INFORMATIONAL_ONLY')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="informationalOnly.value === null"
                                        formControlName="informationalOnly" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="informationalOnly.hasError('required') && (informationalOnly.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('INFORMATIONAL_ONLY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ALLOW-DUPLICATE-REFERRALS' | translate}}
                                    </span>
                                    <input type="checkbox" formControlName="allowDuplicateReferrals" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation"
                                        *ngIf="allowDuplicateReferrals.hasError('required') && allowDuplicateReferrals.touched"
                                        role="alert">
                                        {{'IMPORT-COMMUNITY-PROGRAMS-ALLOW-DUPLICATE-REFERRALS-REQUIRED' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'ADDRESS' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form tab-address">
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STREET' | translate}} {{requiredLabel('STREET')}}
                                    </span>
                                    <input id="streetLine" kendoTextBox formControlName="streetLine" class="w-100" /> <i
                                        *ngIf="addressAPIEnabled && streetLine.value"
                                        class="far fa-search-location pointer ml-3 fa-1_5x"
                                        style="color:#3e807c;position:absolute;top:43px;"
                                        title="{{'VALIDATE-ADDRESS-ICON' | translate}}" (click)="validateAddress()"></i>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="streetLine.hasError('required') && (streetLine.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('STREET')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ADDRESS-LINE-2' | translate}} {{requiredLabel('ADDRESS_LINE_2')}}
                                    </span>
                                    <input id="streetLineAdditional" kendoTextBox formControlName="streetLineAdditional"
                                        class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="streetLineAdditional.hasError('required') && (streetLineAdditional.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ADDRESS_LINE_2')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'CITY' | translate}} {{requiredLabel('CITY')}}
                                    </span>
                                    <input id="city" kendoTextBox formControlName="city" class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="city.hasError('required') && (city.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('CITY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STATE' | translate}} {{requiredLabel('STATE')}}
                                    </span>
                                    <kendo-combobox id="state" class="w-100" formControlName="state" [data]="states"
                                        [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="state.hasError('required') && (state.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('STATE')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'POSTAL-CODE' | translate}} {{requiredLabel('POSTAL_CODE')}}
                                    </span>
                                    <input id="postalCode" kendoTextBox formControlName="postalCode" class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="postalCode.hasError('required') && (postalCode.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('POSTAL_CODE')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COUNTRY' | translate}} {{requiredLabel('COUNTRY')}}
                                    </span>
                                    <kendo-combobox id="country" class="w-100" formControlName="country"
                                        [data]="countries" [textField]="'displayName'" [valueField]="'code'"
                                        [valuePrimitive]="false">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="country.hasError('required') && (country.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('COUNTRY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'CONTACT-INFO' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form tab-address">
                        <div class="row mt-3">
                            <div class="col w-100">
                                <h6 class="text-uppercase" style="border-bottom: 1px solid rgba(0,0,0,.1);">
                                    {{'PROGRAM-MANAGER' | translate}}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-signature fa-fw"></i> {{'NAME' | translate}}
                                        {{requiredLabel('PROGRAM_CONTACT_NAME')}}
                                    </span>
                                    <kendo-maskedtextbox id="programContactName" formControlName="programContactName"
                                        class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="programContactName.hasError('required') && (programContactName.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('PROGRAM_CONTACT_NAME')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-phone fa-fw"></i> {{'PHONE' | translate}}
                                        {{requiredLabel('PROGRAM_CONTACT_PHONE')}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="phoneNumber"
                                        formControlName="phoneNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="phoneNumber.hasError('required') && (phoneNumber.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('PROGRAM_CONTACT_PHONE')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-fax fa-fw"></i> {{'FAX' | translate}}
                                        {{requiredLabel('PROGRAM_CONTACT_FAX')}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="faxNumber"
                                        formControlName="faxNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="faxNumber.hasError('required') && (faxNumber.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('PROGRAM_CONTACT_FAX')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}
                                        {{requiredLabel('PROGRAM_CONTACT_EMAIL')}} &nbsp;
                                    </span>
                                    <input id="email" kendoTextBox formControlName="email" email class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="email.hasError('required') && (email.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('PROGRAM_CONTACT_EMAIL')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="email.invalid && email.touched">
                                        {{'WRONG-EMAIL-FORMAT' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i (click)="openUrl()" [ngClass]="{'has-valid-url': isValidUrl()}"
                                            class="fas fa-link fa-fw"></i> {{'URL' | translate}}
                                        {{requiredLabel('PROGRAM_CONTACT_URL')}}&nbsp;
                                    </span>
                                    <input id="url" kendoTextBox formControlName="url" class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="url.hasError('required') && (url.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('PROGRAM_CONTACT_URL')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="!isValidUrl() && url.hasError('pattern') && url.touched">
                                        {{'INVALID-WWW' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col w-100">
                                <h6 class="text-uppercase" style="border-bottom: 1px solid rgba(0,0,0,.1);">
                                    {{'REFERRAL-COORDINATOR' | translate}}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-signature fa-fw"></i> {{'NAME' | translate}}
                                        {{requiredLabel('REFERRAL_CONTACT_NAME')}}
                                    </span>
                                    <kendo-maskedtextbox id="referralContactName" formControlName="referralContactName"
                                        class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralContactName.hasError('required') && (referralContactName.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_NAME')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-phone fa-fw"></i> {{'PHONE' | translate}}
                                        {{requiredLabel('REFERRAL_CONTACT_PHONE')}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="referralPhoneNumber"
                                        formControlName="referralPhoneNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralPhoneNumber.hasError('required') && (referralPhoneNumber.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_PHONE')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-phone fa-fw"></i> {{'PHONE-EXTENSION' | translate}}
                                        {{requiredLabel('REFERRAL_CONTACT_EXTENSION')}}
                                    </span>
                                    <input id="referralExtension" kendoTextBox formControlName="referralExtension"
                                        class="w-100" maxlength="20" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralExtension.hasError('required') && (referralExtension.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_EXTENSION')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-phone fa-fw"></i> {{'EMERGENCY-NUMBER' | translate}}
                                        {{requiredLabel('REFERRAL_CONTACT_EMERGENCY_NUMBER')}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="emergencyContactMask" id="referralEmergencyNumber"
                                        formControlName="referralEmergencyNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralEmergencyNumber.hasError('required') && (referralEmergencyNumber.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_EMERGENCY_NUMBER')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3"></div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-fax fa-fw"></i> {{'FAX' | translate}}
                                        {{requiredLabel('REFERRAL_CONTACT_FAX')}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="referralFaxNumber"
                                        formControlName="referralFaxNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralFaxNumber.hasError('required') && (referralFaxNumber.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_FAX')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3"></div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}
                                        {{requiredLabel('REFERRAL_CONTACT_EMAIL')}}&nbsp;
                                    </span>
                                    <input id="email" kendoTextBox formControlName="referralEmail" email
                                        class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralEmail.hasError('required') && (referralEmail.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_EMAIL')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralEmail.invalid && referralEmail.touched">
                                        {{'WRONG-EMAIL-FORMAT' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i (click)="openReferralUrl()"
                                            [ngClass]="{'has-valid-url': isValidReferralUrl()}"
                                            class="fas fa-link fa-fw"></i>
                                        {{'URL' | translate}} {{requiredLabel('REFERRAL_CONTACT_URL')}}&nbsp;
                                    </span>
                                    <input id="referralUrl" kendoTextBox formControlName="referralUrl" class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="referralUrl.hasError('required') && (referralUrl.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('REFERRAL_CONTACT_URL')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="!isValidReferralUrl() && referralUrl.hasError('pattern') && referralUrl.touched">
                                        {{'INVALID-WWW' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col w-100">
                                <h6 class="text-uppercase" style="border-bottom: 1px solid rgba(0,0,0,.1);">
                                    {{'DIRECTORY-MANAGER' | translate}}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-signature fa-fw"></i> {{'NAME' | translate}}
                                        {{requiredLabel('DIRECTORY_MANAGER_NAME')}}
                                    </span>
                                    <kendo-maskedtextbox id="directoryManagerName"
                                        formControlName="directoryManagerName" class="w-100">
                                    </kendo-maskedtextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="directoryManagerName.hasError('required') && (directoryManagerName.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('DIRECTORY_MANAGER_NAME')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}
                                        {{requiredLabel('DIRECTORY_MANAGER_EMAIL')}}&nbsp;
                                    </span>
                                    <input id="email" kendoTextBox formControlName="directoryManagerEmail" email
                                        class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="directoryManagerEmail.hasError('required') && (directoryManagerEmail.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('DIRECTORY_MANAGER_EMAIL')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="directoryManagerEmail.invalid && directoryManagerEmail.touched">
                                        {{'WRONG-EMAIL-FORMAT' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'NOTIFICATION-PREFERENCE' | translate}}
                                        {{requiredLabel('DIRECTORY_MANAGER_NOTIFICATION_PREFERENCE')}}
                                    </span>
                                    <div>
                                        <span>
                                            <input type="radio" value="IMMEDIATE"
                                                name="directoryManagerNotificationPreference"
                                                formControlName="directoryManagerNotificationPreference"
                                                id="radioCareTeam" kendoRadioButton />
                                            <label class="k-radio-label" for="radioCareTeam">{{'IMMEDIATE' |
                                                translate}}
                                            </label>
                                            <input type="radio" value="DAILY_DIGEST"
                                                name="directoryManagerNotificationPreference"
                                                formControlName="directoryManagerNotificationPreference"
                                                id="radioDailyDigest" kendoRadioButton />
                                            <label class="k-radio-label" for="radioDailyDigest">{{'DAILY-DIGEST' |
                                                translate:patientLabel}}
                                            </label>
                                            <input type="radio" value="WEEKLY_DIGEST"
                                                name="directoryManagerNotificationPreference"
                                                formControlName="directoryManagerNotificationPreference"
                                                id="radioWeeklyDigest" kendoRadioButton />
                                            <label class="k-radio-label" for="radioWeeklyDigest">{{'WEEKLY-DIGEST' |
                                                translate}}
                                            </label>
                                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                                *ngIf="directoryManagerNotificationPreference.hasError('required') && (directoryManagerNotificationPreference.touched || (editForm.dirty && !isNew))">
                                                {{'REQUIRED-NOTIFICATION-PREFERENCE' | translate}}
                                            </div>
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'WEBSITES' | translate }}">
                <ng-template kendoTabContent>
                    <div class="tab-opening-hours">
                        <div class="p-1">
                            <button kendoButton [primary]="true" (click)="addWebsite()" type="button" class="mb-2">
                                {{'ADD-WEBSITE' | translate}}<i class="far fa-plus"></i>
                            </button>
                            <div formArrayName="websites" class="container-websites">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{
                                                    'WEBSITE-NAME'
                                                    |
                                                    translate }}
                                                </label>
                                            </th>
                                            <th></th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'WEBSITE-URL'
                                                    |
                                                    translate }}
                                                    *
                                                </label>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let option of editForm.controls.websites.controls; let i=index"
                                            [formGroupName]="i">
                                            <td style="width:50%">
                                                <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                                            </td>
                                            <td>
                                                <i (click)="openWebsiteUrl(editForm.controls.websites.controls[i].controls.url.value)"
                                                    [ngClass]="{'has-valid-url': isValidWebsiteUrl(editForm.controls.websites.controls[i].controls.url.value),
                                                                'hidden-control': editForm.controls.websites.controls[i].controls.url.value === null || !isValidWebsiteUrl(editForm.controls.websites.controls[i].controls.url.value)}"
                                                    class="fas fa-link fa-fw mt-2"></i>
                                            </td>
                                            <td style="width:50%">
                                                <input id="url" kendoTextBox formControlName="url" maxlength="1000" />
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.websites.controls[i].controls.url.hasError('required') &&
                                                           editForm.controls.websites.controls[i].controls.url.touched">
                                                    {{ 'REQUIRED-URL' | translate }}
                                                </div>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="!isValidWebsiteUrl(editForm.controls.websites.controls[i].controls.url.value) && 
                                                            editForm.controls.websites.controls[i].controls.url.hasError('pattern') && 
                                                            editForm.controls.websites.controls[i].controls.url.touched">
                                                    {{'INVALID-WWW' | translate}}
                                                </div>
                                            </td>
                                            <td>
                                                <a title="{{ 'DELETE' | translate }}"
                                                    (click)="removeWebsite(i,editForm.controls.websites.controls[i].controls.id.value)">
                                                    <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'OPEN-HOURS' | translate }}">
                <ng-template kendoTabContent>
                    <div class="tab-opening-hours">
                        <div class="p-1">
                            <button kendoButton [primary]="true" (click)="addTime()" type="button" class="mb-2">
                                {{'ADD-OPEN-HOUR' | translate}}<i class="far fa-plus"></i>
                            </button>
                            <div formArrayName="openingTimes" class="container-opening-times">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'DAY' |
                                                    translate }}
                                                    *</label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'FROM' |
                                                    translate }}
                                                    *
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'TO' |
                                                    translate }}
                                                    *</label>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let option of editForm.controls.openingTimes.controls; let i=index"
                                            [formGroupName]="i">
                                            <td style="width:30%">
                                                <kendo-combobox formControlName="day" [data]="days" [textField]="'text'"
                                                    [valueField]="'value'" [valuePrimitive]="true" class="w-100">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.openingTimes.controls[i].controls.day.hasError('required') && 
                                                               editForm.controls.openingTimes.controls[i].controls.day.touched">
                                                    {{ 'REQUIRED-DAY' | translate }}
                                                </div>
                                            </td>
                                            <td style="width:30%">
                                                <kendo-timepicker formControlName="from"></kendo-timepicker>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.openingTimes.controls[i].controls.from.hasError('required') &&
                                                               editForm.controls.openingTimes.controls[i].controls.from.touched">
                                                    {{ 'REQUIRED-FROM' | translate }}
                                                </div>
                                            </td>
                                            <td style="width:30%">
                                                <kendo-timepicker formControlName="to"></kendo-timepicker>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.openingTimes.controls[i].controls.to.hasError('required') &&
                                                               editForm.controls.openingTimes.controls[i].controls.to.touched">
                                                    {{ 'REQUIRED-TO' | translate }}
                                                </div>
                                            </td>
                                            <td>
                                                <a title="{{ 'DELETE' | translate }}"
                                                    (click)="removeTime(i,editForm.controls.openingTimes.controls[i].controls.id.value)">
                                                    <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'WAIT-TIMES' | translate }}">
                <ng-template kendoTabContent>
                    <div class="tab-opening-hours">
                        <div class="p-1">
                            <button kendoButton [primary]="true" (click)="addWaitTime()" type="button" class="mb-2">
                                {{'ADD-WAIT-TIME' | translate}}<i class="far fa-plus"></i>
                            </button>
                            <div formArrayName="waitTimes" class="container-wait-times">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'LOCATION-ID'
                                                    |
                                                    translate }}
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'WAIT-TIME' |
                                                    translate }}
                                                    *
                                                </label>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let option of editForm.controls.waitTimes.controls; let i=index"
                                            [formGroupName]="i">
                                            <td style="width:50%">
                                                <input id="locationID" kendoTextBox formControlName="locationID"
                                                    maxlength="255" />
                                            </td>
                                            <td style="width:50%">
                                                <input id="waitTime" kendoTextBox formControlName="waitTime"
                                                    maxlength="255" />
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.waitTimes.controls[i].controls.waitTime.hasError('required') &&
                                                                                   editForm.controls.waitTimes.controls[i].controls.waitTime.touched">
                                                    {{ 'REQUIRED-WAIT-TIME' | translate }}
                                                </div>
                                            </td>
                                            <td>
                                                <a title="{{ 'DELETE' | translate }}"
                                                    (click)="removeWaitTime(i,editForm.controls.waitTimes.controls[i].controls.id.value)">
                                                    <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'ADDITIONAL-INFO' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form tab-program">
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'APPLICATION-PROCESS' | translate}} {{requiredLabel('APPLICATION_PROCESS')}}
                                    </span>
                                    <textarea id="applicationProcess" kendoTextArea class="w-100"
                                        formControlName="applicationProcess" maxlength="4000" rows="1">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="applicationProcess.hasError('required') && (applicationProcess.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('APPLICATION_PROCESS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ALERT-DESCRIPTION' | translate}} {{requiredLabel('ALERT_DESCRIPTION')}}
                                    </span>
                                    <textarea id="alertDescription" kendoTextArea class="w-100"
                                        formControlName="alertDescription" maxlength="4000" rows="1">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="alertDescription.hasError('required') && (alertDescription.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ALERT_DESCRIPTION')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'DOCUMENTATION-REQUIRED' | translate}}
                                        {{requiredLabel('DOCUMENTATION_REQUIRED')}}
                                    </span>
                                    <textarea id="documentationRequired" kendoTextArea class="w-100"
                                        formControlName="documentationRequired" maxlength="4000" rows="1">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="documentationRequired.hasError('required') && (documentationRequired.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('DOCUMENTATION_REQUIRED')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-2">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'CAPACITY' | translate}} {{requiredLabel('CAPACITY')}}
                                    </span>
                                    <input id="capacity" kendoTextBox formControlName="capacity" maxlength="50" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="capacity.hasError('required') && (capacity.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('CAPACITY')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ACCEPTING-DISABLED-PATIENTS' | translate:patientLabel}}
                                        {{requiredLabel('ACCEPTING_DISABLED_PATIENTS')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="acceptingDisabledPatients.value === null"
                                        formControlName="acceptingDisabledPatients" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="acceptingDisabledPatients.hasError('required') && (acceptingDisabledPatients.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ACCEPTING_DISABLED_PATIENTS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>

                            </div>
                            <div class="col-5">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ACCEPTING-ELECTRONIC-REFERRALS' | translate}}
                                        {{requiredLabel('ACCEPTING_ELECTRONIC_REFERRALS')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="acceptingElectronicReferrals.value === null"
                                        formControlName="acceptingElectronicReferrals" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="acceptingElectronicReferrals.hasError('required') && (acceptingElectronicReferrals.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ACCEPTING_ELECTRONIC_REFERRALS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'LGBTQ' | translate}} {{requiredLabel('LGBTQ')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="lgbtq.value === null"
                                        formControlName="lgbtq" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="lgbtq.hasError('required') && (lgbtq.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('LGBTQ')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row" style="margin-top:-15px;">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ACCEPTING-NEW-PATIENTS' | translate:patientLabel}}
                                        {{requiredLabel('ACCEPTING_NEW_PATIENTS')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="acceptingNewPatients.value === null"
                                        formControlName="acceptingNewPatients" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="acceptingNewPatients.hasError('required') && (acceptingNewPatients.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ACCEPTING_NEW_PATIENTS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-5">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ACCEPTING-SELF-REFERRALS' | translate}}
                                        {{requiredLabel('ACCEPTING_SELF_REFERRALS')}}
                                    </span>
                                    <input type="checkbox" [indeterminate]="acceptingSelfReferrals.value === null"
                                        formControlName="acceptingSelfReferrals" kendoCheckBox />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="acceptingSelfReferrals.hasError('required') && (acceptingSelfReferrals.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('ACCEPTING_SELF_REFERRALS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label for="paymentMethods" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'PAYMENT-METHODS' | translate }} {{requiredLabel('PAYMENT_METHODS')}}
                                    </span>
                                    <kendo-multiselect id="paymentMethods" [data]="paymentMethodsFiltered"
                                        formControlName="paymentMethods" [textField]="'displayName'" [filterable]="true"
                                        [valueField]="'id'" (filterChange)="filterPaymentMethods($event)"
                                        (close)="searchTerm=''" [autoClose]="true" [virtual]="virtualPaymentMethod">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="paymentMethods.hasError('required') && (paymentMethods.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('PAYMENT_METHODS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label for="incomeRequirements" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'INCOME-REQUIREMENTS' | translate }} {{requiredLabel('INCOME_REQUIREMENTS')}}
                                    </span>
                                    <kendo-multiselect id="incomeRequirements" [data]="incomeRequirementsFiltered"
                                        formControlName="incomeRequirements" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterIncomeRequirements($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualIncomeRequirement">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="incomeRequirements.hasError('required') && (incomeRequirements.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('INCOME_REQUIREMENTS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label for="targetedDemographics" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'TARGETED-DEMOGRAPHICS' | translate }}
                                        {{requiredLabel('TARGETED_DEMOGRAPHICS')}}
                                    </span>
                                    <kendo-multiselect id="targetedDemographics" [data]="targetedDemographicsFiltered"
                                        formControlName="targetedDemographics" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterTargetedDemographics($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualTargetedDemographic">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="targetedDemographics.hasError('required') && (targetedDemographics.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('TARGETED_DEMOGRAPHICS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label for="targetedPopulations" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'TARGETED-POPULATIONS' | translate }}
                                        {{requiredLabel('TARGETED_POPULATIONS')}}
                                    </span>
                                    <kendo-multiselect id="targetedPopulations" [data]="targetedPopulationsFiltered"
                                        formControlName="targetedPopulations" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterTargetedPopulations($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualTargetedPopulation">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="targetedPopulations.hasError('required') && (targetedPopulations.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('TARGETED_POPULATIONS')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row pb-3">
                            <div class="col-6">
                                <label for="providerTaxonomies" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'TAXONOMIES' | translate }} {{requiredLabel('TAXONOMIES')}}
                                    </span>
                                    <kendo-multiselect id="providerTaxonomies" [data]="providerTaxonomiesFiltered"
                                        formControlName="providerTaxonomies" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterProviderTaxonomies($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualProviderTaxonomy">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="providerTaxonomies.hasError('required') && (providerTaxonomies.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('TAXONOMIES')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label for="licenses" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'LICENSES' | translate }} {{requiredLabel('translate')}}
                                    </span>
                                    <kendo-multiselect id="licenses" [data]="licensesFiltered"
                                        formControlName="licenses" [textField]="'displayName'" [filterable]="true"
                                        [valueField]="'id'" (filterChange)="filterLicenses($event)"
                                        (close)="searchTerm=''" [autoClose]="true" [virtual]="virtualLicense">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="licenses.hasError('required') && (licenses.touched || (editForm.dirty && !isNew))">
                                        <span translate
                                            [translateParams]="{field: requiredText('LICENSES')}">{{'IS-REQUIRED'}}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'IDENTIFIERS' | translate }}">
                <ng-template kendoTabContent>
                    <div class="tab-opening-hours">
                        <div class="p-1">
                            <button kendoButton [primary]="true" (click)="addOtherIdentifier()" type="button"
                                class="mb-2">
                                {{'ADD-IDENTIFIER' | translate}}<i class="far fa-plus"></i>
                            </button>
                            <div formArrayName="otherIdentifiers" class="container-other-identifiers">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'TYPE'
                                                    | translate }} *
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'VALUE' |
                                                    translate }} *
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{
                                                    'ASSIGNING-AUTHORITY' | translate }}
                                                </label>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let option of editForm.controls.otherIdentifiers.controls; let i=index"
                                            [formGroupName]="i">
                                            <td style="width:30%">
                                                <kendo-combobox formControlName="typeDictionary" [data]="types"
                                                    [textField]="'displayName'" [valueField]="'id'"
                                                    [valuePrimitive]="false" class="w-100">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.otherIdentifiers.controls[i].controls.typeDictionary.hasError('required') && 
                                                                                         editForm.controls.otherIdentifiers.controls[i].controls.typeDictionary.touched">
                                                    {{ 'REQUIRED-IDENTIFIER-TYPE' | translate }}
                                                </div>
                                            </td>
                                            <td style="width:25%">
                                                <input id="value" kendoTextBox formControlName="value" maxlength="50" />
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.otherIdentifiers.controls[i].controls.value.hasError('required') &&
                                                           editForm.controls.otherIdentifiers.controls[i].controls.value.touched">
                                                    {{ 'REQUIRED-IDENTIFIER-VALUE' | translate }}
                                                </div>
                                            </td>
                                            <td style="width:35%">
                                                <kendo-combobox formControlName="assigningAuthorityDictionary"
                                                    [data]="assigningAuthorities" [textField]="'displayName'"
                                                    [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                                                </kendo-combobox>
                                            </td>
                                            <td>
                                                <a title="{{ 'DELETE' | translate }}"
                                                    (click)="removeOtherIdentifier(i,editForm.controls.otherIdentifiers.controls[i].controls.id.value)">
                                                    <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'EXTENSIONS' | translate }}"
                *ngIf="viewExtensions?.gridData?.total > 0 || communityServiceExtensionsEditable">
                <ng-template kendoTabContent>
                    <kendo-grid [data]="viewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [navigable]="true" [sort]="viewExtensions.state.sort" [resizable]="true"
                        style="max-height: 400px;" class="mt-2 mb-2"
                        (dataStateChange)="communityServiceExtensionsDataStateChange($event)" [kendoGridSelectBy]="'id'"
                        (add)="communityServiceExtensionAddHandler($event)"
                        (save)="communityServiceExtensionSaveHandler($event)"
                        (edit)="communityServiceExtensionEditHandler($event)"
                        (cancel)="communityServiceExtensionCancelHandler($event)">
                        <kendo-grid-messages noRecords="{{ 'NO-EXTENSIONS' | translate }}"></kendo-grid-messages>
                        <!--Extension Name-->
                        <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}"
                            [filterable]="false" [sortable]="true">
                            <ng-template kendoGridEditTemplate let-dataItem="dataItem"
                                let-formGroup="communityServiceExtensionFormGroup">
                                <kendo-dropdownlist [data]="extensionsByCategoryAndOrganizationUnused" textField="name"
                                    valueField="id" [valuePrimitive]="false"
                                    [formControl]="communityServiceExtensionFormGroup.get('settingExtension')">
                                </kendo-dropdownlist>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.displayLabel}}"
                                    *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <!--Extension Value-->
                        <kendo-grid-column field="value" [width]="40" title="{{ 'VALUE' | translate }}">
                            <ng-template kendoGridEditTemplate>
                                <div [formGroup]="communityServiceExtensionFormGroup">
                                    <input kendoTextBox formControlName="value" maxlength="10485760" />
                                </div>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span *ngIf="dataItem.value">{{formatExtensionValue(dataItem)}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center"
                            *ngIf="!isReadOnly && communityServiceExtensionsEditable">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <ng-container *ngIf="dataItem.editing">
                                    <ng-container
                                        *ngIf="communityServiceExtensionFormGroup !== null && communityServiceExtensionFormGroup.valid">
                                        <i class="fas fa-check fa-lg icon-success pointer"
                                            title="{{'SAVE' | translate}}"
                                            (click)="communityServiceExtensionSaveButton.click.emit($event); dataItem.editing = false">
                                        </i>
                                        &nbsp;
                                    </ng-container>
                                    <i class="fas fa-times-circle fa-lg icon-neutral pointer"
                                        title="{{'CANCEL' | translate}}"
                                        (click)="communityServiceExtensionCancelButton.click.emit($event); dataItem.editing = false;"></i>
                                    <button kendoGridSaveCommand #communityServiceExtensionSaveButton
                                        class="d-none"></button>
                                    <button kendoGridCancelCommand #communityServiceExtensionCancelButton
                                        class="d-none"></button>
                                </ng-container>
                                <ng-container *ngIf="!dataItem.editing">
                                    <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                                        (click)="communityServiceExtensionEditButton.click.emit($event); dataItem.editing = true;"></i>
                                    &nbsp;
                                    <button kendoGridEditCommand #communityServiceExtensionEditButton
                                        class="d-none"></button>
                                    <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                                        (click)="deleteCommunityServiceExtension(dataItem)"></i>
                                </ng-container>
                            </ng-template>
                        </kendo-grid-command-column>
                        <button kendoGridAddCommand #communityServiceExtensionAddButton class="d-none"></button>
                    </kendo-grid>
                    <button *ngIf="!isReadOnly && communityServiceExtensionsEditable" kendoButton [primary]="false"
                        type="button" class="float-right mt-2 mb-3"
                        (click)="communityServiceExtensionAddButton.click.emit($event);">{{'ADD' | translate}}<i
                            class="far fa-plus"></i>
                    </button>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3 ml-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty || saving"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-address-validator #addressValidator (changeAddress)="changeAddress($event)" (save)="saveService()"
    (cancelling)="saving = false;">
</app-address-validator>